import dayjs from "dayjs";
import { SyncOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import type { LunchMenuSummary } from "../../../../api/lunchMenus";
import { DISPLAY_DATE, ISO_DATE } from "../lunchDraft";

/** Статусът на обедно меню: активно сега (зелено) · предстои (кехлибар) · изтекло (сиво). */
export const LunchStatusPill = ({ menu }: { menu: LunchMenuSummary }) => {
  const { t } = useTranslation();
  const base =
    "inline-flex h-6 shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 text-xs font-semibold";

  if (menu.status === "live")
    return (
      <span className={`${base} bg-pos-served-bg text-pos-served`}>
        <span aria-hidden className="h-[7px] w-[7px] rounded-full bg-current" />
        {t("lunchMenu.statusLive")}
      </span>
    );

  if (menu.status === "past")
    return (
      <span className={`${base} bg-pos-none-bg text-pos-none`}>
        {t("lunchMenu.statusPast")}
      </span>
    );

  const today = dayjs().format(ISO_DATE);
  const tomorrow = dayjs().add(1, "day").format(ISO_DATE);
  const recurring = (menu.weekdays?.length ?? 0) > 0 || menu.dateTo == null;
  const label = recurring
    ? t("lunchMenu.statusRecurring")
    : menu.nextDate === today
      ? t("lunchMenu.statusToday")
      : menu.nextDate === tomorrow
        ? t("lunchMenu.statusTomorrow")
        : menu.nextDate
          ? dayjs(menu.nextDate).format(DISPLAY_DATE)
          : t("lunchMenu.statusUpcoming");
  return (
    <span className={`${base} bg-pos-marked text-pos-accent-ink`}>
      {recurring && <SyncOutlined className="text-[11px]" />}
      <span className="font-pos-mono">{label}</span>
    </span>
  );
};
